module.exports = __webpack_public_path__ + "static/media/MU.8400b4ab.svg";